<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MailAccountConfig"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :readonly="resource.locked"
      :labelAlign="$config.forms.defaultLabelAlign"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpRow>
        <ItpCol>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="address"
            :label="config.address.label"
            :helpTooltip="config.address.help"
            required
          >
            <ItpFormInput
              name="address"
              v-model="editor.address"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="description"
            :label="config.description.label"
            :helpTooltip="config.description.help"
          >
            <ItpFormInput
              name="description"
              v-model="editor.description"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <HR>
          </HR>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="use_credentials"
            :label="config.use_credentials.label"
            :helpTooltip="config.use_credentials.help"
          >
            <ItpFormCheckbox
              name="use_credentials"
              v-model="editor.use_credentials"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="username"
            :label="config.username.label"
            :helpTooltip="config.username.help"
            required
          >
            <ItpFormInput
              name="username"
              v-model="editor.username"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="password"
            :label="config.password.label"
            :helpTooltip="config.password.help"
          >
            <ItpFormInput
              type="password"
              name="password"
              v-model="change_password.password"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="confirm_password"
            :label="config.confirm_password.label"
            :helpTooltip="config.confirm_password.help"
          >
            <ItpFormInput
              type="password"
              name="confirm_password"
              v-model="change_password.confirm_password"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <HR>
          </HR>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="tls"
            :label="config.tls.label"
            :helpTooltip="config.tls.help"
          >
            <ItpFormCheckbox
              name="tls"
              v-model="editor.tls"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="ssl"
            :label="config.ssl.label"
            :helpTooltip="config.ssl.help"
          >
            <ItpFormCheckbox
              name="ssl"
              v-model="editor.ssl"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="server"
            :label="config.server.label"
            :helpTooltip="config.server.help"
            required
          >
            <ItpFormInput
              name="server"
              v-model="editor.server"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="2"
            name="port"
            :label="config.port.label"
            :helpTooltip="config.port.help"
            required
          >
            <ItpFormInput
              type="number"
              name="port"
              v-model="editor.port"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="mail_from_name"
            :label="config.mail_from_name.label"
            :helpTooltip="config.mail_from_name.help"
            required
          >
            <ItpFormInput
              name="mail_from_name"
              v-model="editor.mail_from_name"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="validate_certs"
            :label="config.validate_certs.label"
            :helpTooltip="config.validate_certs.help"
          >
            <ItpFormCheckbox
              name="validate_certs"
              v-model="editor.validate_certs"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="2"
            name="timeout"
            :label="config.timeout.label"
            :helpTooltip="config.timeout.help"
            required
            contentClass="input-group"
          >
            <ItpFormInput
              type="number"
              name="timeout"
              v-model="editor.timeout"
              required
            >
            </ItpFormInput>
            <DIV
              class="input-group-append"
            >
              <span
                class="input-group-text"
              >
                sec
              </span>
            </DIV>
          </ItpFormGroup>
        </ItpCol>
      </ItpRow>
    </ItpForm>
    <ItpForm
      :name="sendTestEmailFormName"
      :labelAlign="$config.forms.defaultLabelAlign"
      v-if="!resource.isNew"
      @submit="evh_4186377094414664_submit($event, {})"
    >
      <hr>
      </hr>
      <ItpFormGroup
        labelColsMd="3"
        contentColsMd="9"
        name="recipient"
        :label="'Send test email'|pgettext('MailAccountConfig')"
        required
      >
        <DIV
          class="input-group"
        >
          <ItpFormInput
            name="recipient"
            v-model="recipient"
            required
          >
          </ItpFormInput>
          <div
            class="input-group-append"
          >
            <ItpButton
              type="submit"
              :text="'Send'|pgettext('MailAccountConfig|Button')"
              :spinning="actions.sendTestEmail.isRunning"
              @click.prevent.stop="evh_4699325371235600_clickPreventStop($event, {})"
            >
            </ItpButton>
          </div>
        </DIV>
        <ItpAlert
          type="success"
          :show="sendMailTestResult === 'success'"
          dismissible
          class="mt-3"
        >
          <span>
            {{ 'Email has been successfully sent.'|pgettext('MailAccountConfig') }}
          </span>
        </ItpAlert>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Delete'|pgettext('Button')"
      variant="danger"
      icon="fa-times"
      :spinning="actions.delete.isRunning"
      class="mr-auto"
      v-if="!resource.isNew"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :form="forms[formName] && forms[formName].id"
      :text="'Save'|pgettext('Button')"
      type="submit"
      variant="primary"
      default
      :spinning="actions.submit && actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('Button')"
      variant="default"
      :disabled="actions.submit && actions.submit.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MailAccountConfig extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  recipient!: any;

  async $$load_recipient() {
    return this.$app.auth.user.email
  }

  sendMailTestResult!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  sendTestEmailFormId!: any;

  async $$load_sendTestEmailFormId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  sendTestEmailFormName!: any;
  config!: any;
  resource!: any;

  async $$load_resource() {
    return this.oid
      ? this.$fn.fetch('get_object_by_type', { parameters: { id: this.oid, object_type: 'mail-account' }, asResource: true })
      : new this.$fn.Resource(
        _.reduce(this.$data.config, (m, v, k) => _.set(m, k, _.get(v, 'default', null)))
      )
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  change_password!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['recipient', 'sendMailTestResult', 'formId', 'sendTestEmailFormId', 'formName', 'sendTestEmailFormName', 'config', 'resource', 'editor', 'change_password', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        recipient: null,
        sendMailTestResult: null,
        formId: null,
        sendTestEmailFormId: null,
        formName: "MailAccountConfig",
        sendTestEmailFormName: "SendTestEmail",
        config: {
          tls: {
            label: this.$fn.pgettext("MailAccount", "Use TLS"),
            help: this.$fn.pgettext("MailAccount", "Enable TLS encryption for the connection."),
            default: true,
          }
          ,
          ssl: {
            label: this.$fn.pgettext("MailAccount", "SSL"),
            help: this.$fn.pgettext("MailAccount", "Use SSL to secure the connection."),
            default: true,
          }
          ,
          use_credentials: {
            label: this.$fn.pgettext("MailAccount", "Use Credentials"),
            help: this.$fn.pgettext("MailAccount", "Require username and password to authenticate."),
            default: true,
          }
          ,
          validate_certs: {
            label: this.$fn.pgettext("MailAccount", "Validate Certificates"),
            help: this.$fn.pgettext("MailAccount", "Check that server certificates are valid."),
            default: true,
          }
          ,
          mail_from_name: {
            label: this.$fn.pgettext("MailAccount", "Mail From Name"),
            help: this.$fn.pgettext("MailAccount", "Name displayed as the sender of the email."),
          }
          ,
          server: {
            label: this.$fn.pgettext("MailAccount", "Server"),
            help: this.$fn.pgettext("MailAccount", "Address of the mail server."),
            default: "smtp.server.com",
          }
          ,
          port: {
            label: this.$fn.pgettext("MailAccount", "Port"),
            help: this.$fn.pgettext("MailAccount", "Port number for the mail server connection."),
            default: 587,
          }
          ,
          debug: {
            label: this.$fn.pgettext("MailAccount", "Debug"),
            help: this.$fn.pgettext("MailAccount", "Show detailed connection and sending logs."),
            default: false,
          }
          ,
          username: {
            label: this.$fn.pgettext("MailAccount", "Username"),
            help: this.$fn.pgettext("MailAccount", "Your login name for authentication."),
          }
          ,
          password: {
            label: this.$fn.pgettext("MailAccount", "Password"),
            help: this.$fn.pgettext("MailAccount", "Your account password."),
          }
          ,
          confirm_password: {
            label: this.$fn.pgettext("MailAccount", "Confirm Password"),
            help: this.$fn.pgettext("MailAccount", "Re-enter password to verify."),
          }
          ,
          timeout: {
            label: this.$fn.pgettext("MailAccount", "Timeout"),
            help: this.$fn.pgettext("MailAccount", "Time to wait before giving up."),
            default: 60,
          }
          ,
          description: {
            label: this.$fn.pgettext("MailAccount", "Description"),
            help: this.$fn.pgettext("MailAccount", "Short note or label for this entry."),
          }
          ,
          address: {
            label: this.$fn.pgettext("MailAccount", "Address"),
            help: this.$fn.pgettext("MailAccount", "Email or server address to use."),
            default: "username@provider.com",
          }
          ,
        }
        ,
        resource: null,
        editor: null,
        change_password: {
          password: null,
          confirm_password: null,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("MailAccountConfig|Title", "Mail account configuration")
          ,
        ]
        ,
        icon: this.$config.settings.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5420_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5420, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_5426_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_5426, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_5424_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_5424, alias=save
    return {
      objectType: "object_by_type",
      op: "upsert",
      data: {
        ...this.editor.getData(),
        'object_type': 'mail-account',
        ...(this.change_password.password && this.change_password.confirm_password ? this.change_password : {})
      },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_closeModal_5430_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_4186377094414664_closeModal_5430, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_4186377094414664_crud_5428_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_4186377094414664_crud_5428, alias=save
    return {
      objectType: "object_by_type",
      op: "upsert",
      data: {
        ...this.editor.getData(),
        'object_type': 'mail-account',
        ...(this.change_password.password && this.change_password.confirm_password ? this.change_password : {})
      },
    }
  }

  async evh_4186377094414664_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
  }

  async act_4699325371235600_setData_5432_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_4699325371235600_setData_5432, alias=undefined
    return {
      path: "sendMailTestResult",
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_4699325371235600_script_5436_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4699325371235600_script_5436, alias=undefined
    this.sendMailTestResult = 'success'
  }

  async act_4699325371235600_script_5436_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4699325371235600_script_5436, alias=undefined
    return {
      value: () => this.act_4699325371235600_script_5436_getActionArgs_value($event),
    }
  }

  async act_4699325371235600_request_5434_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4699325371235600_request_5434, alias=sendTestEmail
    return {
      operation: "post_sendmail_test",
      data: { mail_account: this.resource.id, recipient: this.recipient },
    }
  }

  async evh_4699325371235600_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4699325371235600_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeModal_5440_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1548630417156826_closeModal_5440, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1548630417156826_request_5438_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_5438, alias=delete
    return {
      operation: "delete_object_by_type",
      data: this.resource.getData({ fields: ['id', 'etag'] }),
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_5442_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_5442, alias=undefined
    return {
      name: this.modalName,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5420: actions.CloseModalAction;
    evh_7315092382398562_close_5419: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_5422: actions.CloseComponentAction;
    evh_2248226175642056_close_5421: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_5426: actions.CloseModalAction;
    evh_1040167445267876_success_5425: actions.EventHandlerImpl;
    act_1040167445267876_crud_5424: actions.CRUDAction;
    evh_1040167445267876_submit_5423: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_4186377094414664_closeModal_5430: actions.CloseModalAction;
    evh_4186377094414664_success_5429: actions.EventHandlerImpl;
    act_4186377094414664_crud_5428: actions.CRUDAction;
    evh_4186377094414664_submit_5427: actions.EventHandlerImpl;
    evh_4186377094414664_submit: actions.EventHandlerGroup;
    act_4699325371235600_setData_5432: actions.SetDataAction;
    evh_4699325371235600_clickPreventStop_5431: actions.EventHandlerImpl;
    act_4699325371235600_script_5436: actions.ScriptAction;
    evh_4699325371235600_success_5435: actions.EventHandlerImpl;
    act_4699325371235600_request_5434: actions.RequestAction;
    evh_4699325371235600_clickPreventStop_5433: actions.EventHandlerImpl;
    evh_4699325371235600_clickPreventStop: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_5440: actions.CloseModalAction;
    evh_1548630417156826_success_5439: actions.EventHandlerImpl;
    act_1548630417156826_request_5438: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_5437: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_5442: actions.CloseModalAction;
    evh_2186679009640457_clickPreventStop_5441: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5420 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5420_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5419 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5420,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5419],
      }
    );
    const act_2248226175642056_closeComponent_5422 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5421 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_5422,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5421],
      }
    );
    const act_1040167445267876_closeModal_5426 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_5426_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5425 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_5426,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_5424 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_5424_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_5425],
      }
    );
    const evh_1040167445267876_submit_5423 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_5424,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5423],
      }
    );
    const act_4186377094414664_closeModal_5430 = new actions.CloseModalAction(
      {
        actionArgs: this.act_4186377094414664_closeModal_5430_getActionArgs,
        events: [],
      }
    );
    const evh_4186377094414664_success_5429 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_closeModal_5430,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_4186377094414664_crud_5428 = new actions.CRUDAction(
      {
        actionArgs: this.act_4186377094414664_crud_5428_getActionArgs,
        displayName: "save",
        events: [evh_4186377094414664_success_5429],
      }
    );
    const evh_4186377094414664_submit_5427 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_crud_5428,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_4186377094414664_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_submit_5427],
      }
    );
    const act_4699325371235600_setData_5432 = new actions.SetDataAction(
      {
        actionArgs: this.act_4699325371235600_setData_5432_getActionArgs,
        events: [],
      }
    );
    const evh_4699325371235600_clickPreventStop_5431 = new actions.EventHandlerImpl(
      {
        action: act_4699325371235600_setData_5432,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const act_4699325371235600_script_5436 = new actions.ScriptAction(
      {
        actionArgs: this.act_4699325371235600_script_5436_getActionArgs,
        events: [],
      }
    );
    const evh_4699325371235600_success_5435 = new actions.EventHandlerImpl(
      {
        action: act_4699325371235600_script_5436,
        event: "success",
        displayName: "script",
      }
    );
    const act_4699325371235600_request_5434 = new actions.RequestAction(
      {
        actionArgs: this.act_4699325371235600_request_5434_getActionArgs,
        displayName: "sendTestEmail",
        events: [evh_4699325371235600_success_5435],
      }
    );
    const evh_4699325371235600_clickPreventStop_5433 = new actions.EventHandlerImpl(
      {
        action: act_4699325371235600_request_5434,
        event: "click.prevent.stop",
        displayName: "sendTestEmail",
      }
    );
    const evh_4699325371235600_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4699325371235600_clickPreventStop_5431, evh_4699325371235600_clickPreventStop_5433],
      }
    );
    const act_1548630417156826_closeModal_5440 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1548630417156826_closeModal_5440_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_5439 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_5440,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1548630417156826_request_5438 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_5438_getActionArgs,
        displayName: "delete",
        events: [evh_1548630417156826_success_5439],
      }
    );
    const evh_1548630417156826_clickPreventStop_5437 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_5438,
        event: "click.prevent.stop",
        displayName: "delete",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_5437],
      }
    );
    const act_2186679009640457_closeModal_5442 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_5442_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_5441 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_5442,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_5441],
      }
    );
    return {
      act_7315092382398562_closeModal_5420,
      evh_7315092382398562_close_5419,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_5422,
      evh_2248226175642056_close_5421,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_5426,
      evh_1040167445267876_success_5425,
      act_1040167445267876_crud_5424,
      evh_1040167445267876_submit_5423,
      evh_1040167445267876_submit,
      act_4186377094414664_closeModal_5430,
      evh_4186377094414664_success_5429,
      act_4186377094414664_crud_5428,
      evh_4186377094414664_submit_5427,
      evh_4186377094414664_submit,
      act_4699325371235600_setData_5432,
      evh_4699325371235600_clickPreventStop_5431,
      act_4699325371235600_script_5436,
      evh_4699325371235600_success_5435,
      act_4699325371235600_request_5434,
      evh_4699325371235600_clickPreventStop_5433,
      evh_4699325371235600_clickPreventStop,
      act_1548630417156826_closeModal_5440,
      evh_1548630417156826_success_5439,
      act_1548630417156826_request_5438,
      evh_1548630417156826_clickPreventStop_5437,
      evh_1548630417156826_clickPreventStop,
      act_2186679009640457_closeModal_5442,
      evh_2186679009640457_clickPreventStop_5441,
      evh_2186679009640457_clickPreventStop,
      save: act_4186377094414664_crud_5428,
      sendTestEmail: act_4699325371235600_request_5434,
      delete: act_1548630417156826_request_5438,
    }
  }
}

Vue.component("MailAccountConfig", MailAccountConfig);

</script>